import { useEffect, useState } from 'react';
import { msalInstance } from '../auth/msalInstance';
import { apiRequest } from '../auth/authConfig';

// The MFA-progress metric is owned by the tech app. Its API is reachable from
// here through the same-origin nginx proxy at REACT_APP_TECH_URL (/it on prod,
// /tech on staging), so this is a normal same-origin fetch — no CORS. We attach
// the same MSAL access token the rest of the app uses; the shared Entra app
// registration means the tech server accepts it, and the endpoint is IT-group
// gated server-side (full-admin bypass), matching who can see the IT panel.
const MFA_URL = `${process.env.REACT_APP_TECH_URL || '/it'}/api/mfa/progress`;

// Deliberately a plain fetch hook rather than react-query: it has no dependency
// on a QueryClientProvider being mounted, so it can't crash the IT panel if the
// provider tree ever changes.
export function useMfaProgress() {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const account = msalInstance.getActiveAccount();
        const { accessToken } = await msalInstance.acquireTokenSilent({ ...apiRequest, account });
        const res = await fetch(MFA_URL, { headers: { Authorization: `Bearer ${accessToken}` } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (!cancelled) setData(json);
      } catch {
        if (!cancelled) setIsError(true);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, isLoading, isError };
}
